import React from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";

// Language menu (2026-10-22): a dropdown naming the languages (no icon).
// Persists via i18next's localStorage cache and, when a donation session
// exists, tells the backend (donation_context.ui_language).
const LANGS = [["en", "English"], ["pt-BR", "Português (Brasil)"]];

const LanguageToggle = () => {
    const { i18n, t } = useTranslation();
    const current = (i18n.resolvedLanguage || i18n.language || "en").startsWith("pt") ? "pt-BR" : "en";
    const choose = async (lng) => {
        await i18n.changeLanguage(lng);
        try {
            await axios.post(new URL("/api/client-context", process.env.REACT_APP_BASE_URL), { clientContext: { ui_language: lng } });
        } catch (e) { /* no session yet, or offline — fine */ }
    };
    return (
        <label className="lang-menu" title={t("common.language")}>
            <select id="language-select" aria-label={t("common.language")} value={current} onChange={(e) => choose(e.target.value)}>
                {LANGS.map(([lng, name]) => <option key={lng} value={lng}>{name}</option>)}
            </select>
        </label>
    );
};

export default LanguageToggle;
